// extracted by mini-css-extract-plugin
export default {"input":"uploadField_input__vF2rT","container":"uploadField_container__wQGDo","icon":"uploadField_icon__-sPY7","label":"uploadField_label__Tm5QY"};